"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _sdkLocalStorage = _interopRequireDefault(require("@energych/sdk-local-storage"));

var _client = require("./client");

var _token = _interopRequireDefault(require("./token"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ServerClient =
/*#__PURE__*/
function (_Client) {
  _inherits(ServerClient, _Client);

  function ServerClient() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ServerClient);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ServerClient)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "req", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "res", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "storage", new _sdkLocalStorage.default({
      namespace: 'auth'
    }));

    return _this;
  }

  _createClass(ServerClient, [{
    key: "init",

    /**
     * Parse the access token from the cookie header
     *
     * @param req
     * @param res
     */
    value: function init(req, res) {
      this.req = req;
      this.res = res; // parse access_token cookie

      if (this.req.headers && typeof this.req.headers.cookie === 'string') {
        var accessToken = /(?:\s|^)access_token=([^; $]*)/g.exec(this.req.headers.cookie);

        if (accessToken && accessToken.length > 1) {
          if (this.setAccessToken(new _token.default(accessToken[1]))) {
            this.connector.emit('login', {
              successful: true,
              userInitialized: false
            });
            return;
          }
        }
      }

      this.accessToken = null;
    }
    /**
     * Logout the user
     */

  }, {
    key: "logout",
    value: function logout() {
      if (this.accessToken) {
        this.accessToken = null;
        this.res.clearCookie('access_token');
        this.connector.emit('logout');
      }
    }
    /**
     * Called when a method is called but the access token is invalid or expired
     */

  }, {
    key: "onInvalidToken",
    value: function onInvalidToken() {
      this.logout();
    }
  }]);

  return ServerClient;
}(_client.Client);

exports.default = ServerClient;